// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","container":"SectionMenuList_container__3HcLk","placeholder":"SectionMenuList_placeholder__15RVt"};